import { Swiper } from "swiper";
import { Scrollbar } from "swiper/modules";

import "./addons.scss";

const selectors = {
  addonsContainer: "[data-addons]",
  addonsSwiper: "[data-addons-swiper]",
  addonsSwiperScrollbar: "[data-addons-swiper-scrollbar]",
};

const initAddonsSlider = (container) => {
  new Swiper(container.querySelector(selectors.addonsSwiper), {
    modules: [Scrollbar],

    slidesPerView: "auto",
    spaceBetween: 12,

    scrollbar: {
      el: container.querySelector(selectors.addonsSwiperScrollbar),
    },

    breakpoints: {
      1024: {
        enabled: false,
        spaceBetween: 0,
      },
    },
  });
};

document.addEventListener("DOMContentLoaded", async function () {
  const containers = document.querySelectorAll(selectors.addonsContainer);

  containers?.forEach(initAddonsSlider);
});
